import { Button } from "@material-ui/core";
import { useCallback, useRef, useState } from "react";
import WebCam from "react-webcam";
import { PhotoButton, PhotoButtons, PhotoContainer, PhotoField } from "./styles";

const CustomWebCam = ({ setImage, setMode, onFileUpload }) => {
    const webcamRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();

        setImage(imageSrc);
        setMode("capture");

        setImgSrc(imageSrc);
    }, [webcamRef]);

    const retake = () => {
        setImgSrc(null);
        setMode(null);
    };

    const handleUpload = () => {
        if (imgSrc) {
            onFileUpload(imgSrc);
        }
    };

    return (
        <PhotoContainer>
            <PhotoField>
                {imgSrc ? (
                    <img src={imgSrc} alt="webcam" />
                ) : (
                    <WebCam
                        height={600}
                        width={600}
                        minScreenshotHeight={600}
                        minScreenshotWidth={600}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        screenshotQuality={1}
                    />
                )}
                <div className="btn-container"></div>
            </PhotoField>
            <PhotoButtons>
                {imgSrc ? (
                    <PhotoButton>
                        <Button fullWidth variant="contained" color="primary" onClick={handleUpload}>
                            Salvar Foto
                        </Button>
                        <Button fullWidth variant="contained" color="secondary" onClick={retake}>
                            Tirar outra
                        </Button>
                    </PhotoButton>
                ) : (
                    <PhotoButton>
                        <Button fullWidth variant="contained" color="primary" onClick={capture}>
                            Tirar foto
                        </Button>
                    </PhotoButton>
                )}
            </PhotoButtons>
        </PhotoContainer>
    );
};

export default CustomWebCam;
